module.exports = __webpack_public_path__ + "img/Plus.399bf640.svg";